module.exports = __webpack_public_path__ + "img/917e744.png";